import apiClient from '@/plugins/axios';

function toRoundHistoryItemUpdatePayload(roundHistoryItem = {}) {
	return {
		userName: roundHistoryItem.userName ?? null,
		controlled: roundHistoryItem.controlled ?? null,
		name: roundHistoryItem.name ?? null,
		inventoryType: roundHistoryItem.inventoryType ?? null,
		positionX: roundHistoryItem.positionX ?? 0,
		positionY: roundHistoryItem.positionY ?? 0,
		rotation: roundHistoryItem.rotation ?? 0,
		scale: roundHistoryItem.scale ?? 0,
		positionNumber: roundHistoryItem.positionNumber ?? 0,
		year: roundHistoryItem.year ?? null,
		placementDescription: roundHistoryItem.placementDescription ?? null,
		roundHistoryInfoId: roundHistoryItem.roundHistoryInfoId,
		mapItemId: roundHistoryItem.mapItemId ?? null
	};
}

export default {
	getRoundHistoryItems(searchParam) {
		const langCode = localStorage.getItem('lang') || 'sv';

		let query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.roundHistoryId
			? `&RoundHistoryId=${searchParam.roundHistoryId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += `&langCode=${langCode}`;

		return apiClient.get(`v1/RoundHistoryItem${query}`);
	},

	getRoundHistoryItem(roundHistoryItemId) {
		const langCode = localStorage.getItem('lang') || 'sv';
		return apiClient.get(`v1/RoundHistoryItem/${roundHistoryItemId}`, {
			params: { langCode }
		});
	},


	createRoundHistoryItem(roundHistoryItem) {
		return apiClient.post('v1/RoundHistoryItem', roundHistoryItem);
	},

	updateRoundHistoryItem(roundHistoryItem) {
		var roundHistoryItemId = roundHistoryItem.id;

		return apiClient.put(
			`v1/RoundHistoryItem/${roundHistoryItemId}`,
			toRoundHistoryItemUpdatePayload(roundHistoryItem)
		);
	},

	deleteRoundHistoryItem(roundHistoryItemId) {
		return apiClient.delete(`v1/RoundHistoryItem/${roundHistoryItemId}`);
	}
};
